import { Component, EventEmitter, Output } from '@angular/core';

/** Round chat button shown to anonymous visitors before any chat is loaded. */
@Component({
  selector: 'app-mu-chat-launcher',
  templateUrl: './chat-launcher.component.html',
  styleUrls: ['./chat-launcher.component.sass'],
})
export class MuChatLauncherComponent {
  @Output() readonly pressed = new EventEmitter<void>();
}
